import { createContext, useContext, useState, useEffect } from 'react'
import { getUserCachedData } from 'utils/UserAuthorization'

export const CompanyContext = createContext()

export const CompanyProvider = ({ children }) => {
  // Inicializa synchronously a partir do cache para evitar necessidade
  // de componentes fazerem fallback manualmente.
  const initialUser = getUserCachedData()
  const initialCompany = initialUser?.company || (initialUser?.companyId ? { id: initialUser.companyId } : null)
  const [company, setCompany] = useState(initialCompany)
  const [plan, setPlan] = useState(initialUser?.plan || null)

  useEffect(() => {
    // mantém compatibilidade: se algo atualiza o usuário em background,
    // atualizamos o contexto a partir do cache.
    try {
      const parsed = getUserCachedData()
      if (parsed) {
        if (parsed?.company) setCompany(parsed.company)
        else if (parsed?.companyId) setCompany(current => current || { id: parsed.companyId })
        if (parsed?.plan) setPlan(parsed.plan)
      }
    } catch (e) {
      console.warn('[CompanyContext] failed to load cached user', e)
    }
  }, [])

  const updateCompanyFromUser = (user) => {
    if (user?.company) setCompany(user.company)
    else if (user?.companyId) setCompany({ id: user.companyId })
    else setCompany(null)

    setPlan(user?.plan || null)
  }

  const clearCompany = () => {
    setCompany(null)
    setPlan(null)
  }

  return (
    <CompanyContext.Provider value={{ company, setCompany, plan, setPlan, updateCompanyFromUser, clearCompany }}>
      {children}
    </CompanyContext.Provider>
  )
}

export const useCompany = () => useContext(CompanyContext)
